<template>
  <div id="termNCond">
    <div class="Flex_Table tblEntryForm" v-if="!isCancellationPolicy">
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <span style="font-size: 16pt; align: justify">
            <b>1. BASIC TRAVEL GUIDELINES FOR TOURISTS</b>
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <span style="align: justify">
            The following basic guidelines should be adhered to by all tourists
            while engaging in any tourism activity to ensure their own safety as
            well as the safety of their service providers.
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <span style="font-size: 13pt">
            <b>1.1. GENERAL PREPAREDNESS</b>
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell" style="margin-left: 35px">
          <ul>
            <li>
              <span style="text-align: justify">
                Tourists may need to follow basic screening procedures (like
                temperature check) and hygiene protocols (use of mask and hand
                sanitizers) before using the said services.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                Persons above 65 years of age, persons with comorbidities,
                pregnant women and children below the age of 10 years are
                advised to either avoid completely or limit their travel. While
                travelling, they are advised to take extra precautions.
              </span>
            </li>
            <li>
              <span style="text-align: justify">Before booking ticket:</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell" style="margin-left: 50px">
          <span style="text-align: justify">
            (i) Tourists will have restricted to visit areas falling within
            restricted zone.
          </span>
          <br />
          <span style="text-align: justify">
            (ii) As far as possible, a zero-contact policy should be followed
            by tourists.
          </span>
          <br />
          <span style="text-align: justify">
            (iii) Tourists are advised to plan their visits of any facility /
            tourist attraction / activity by checking their open timings.
          </span>
          <br />
          <span style="text-align: justify">
            (iv) Tourists have to followed allotted time slots for the
            convenience of service providers and other tourists.
          </span>
          <br />
          <span style="text-align: justify">
            (v) Tourists have to avoid handling cash as much as possible. All
            payments should be done through digital modes.
          </span>
          <br />
          <span style="text-align: justify">
            (vi) While travelling all tourist have to wear a face mask and
            carry their own sanitizer and wet wipes for personal use.
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <span style="font-size: 13pt">
            <b>1.2. SAFETY AND HYGIENE</b>
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell" style="margin-left: 35px">
          <ul>
            <li>
              <span style="text-align: justify">
                Tourists have to strictly observe social distancing norms with
                a physical distance of 2 meters (6 feet) per person. Family
                groups can stay together as long as they ensure that are at
                least 2 meters (6 feet) away from any other individuals or
                family groups.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                Tourists have to ensure that they wear a protective face mask
                while within the premises tourism destination.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                Tourists have to frequently wash hands or use hand sanitizers.
                While respective facility / activity / service provider shall
                provide for soaps / sanitizer at common places, tourists have to
                prepared and carry their own sanitizer and wet wipes.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                Tourists have to sanitize their hands after any contact with
                public surfaces including ticketing counters or check-in
                counters.
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <span style="font-size: 13pt">
            <b>1.3. TICKETING AND BOOKINGS</b>
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell" style="margin-left: 35px">
          <ul>
            <li>
              <span style="text-align: justify">
                Tourists have to avail online ticket only and book their
                tickets well in advance. This will ensure that service providers
                have information to make adequate arrangements.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                Tourists having an abnormal temperature and / or flu like
                symptoms shall not be allowed to enter the facility / activity
                premises. The service provider shall note down their contact
                details of such tourists and shall notify relevant health or
                administration authorities for acting on necessary Government
                protocols.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                Any tourist displaying potential COVID-19 symptoms and the
                people accompanying the said tourist shall be moved to a
                containment area or isolation room for further action.
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <span style="font-size: 13pt">
            <b>1.4. REFUND POLICY</b>
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell" style="margin-left: 35px">
          <ul>
            <li>
              <span
                style="text-align: justify"
              >Refund will be applicable only till 72 Hrs prior to visit date.</span>
            </li>
            <li>
              <span style="text-align: justify">
                For refund tourists is requested to send E-mail with ticket No,
                name and mobile No through which ticket was booked on
                <img
                  src="../assets/images/Email1.png"
                  valign="bottom"
                />
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                The refund will be initiated within 96 hrs of receipt of e-mail
                excluding bank holidays/strike.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                In case of money has been deducted from account and ticket has
                not been booked due to any technical error or connectivity issue
                or otherwise,
                <b>BRO</b> will
                <b>NOT</b> be responsible.
                However, the complete refund will be initiated on receipt of e
                mail.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                In case of any query the nodal Officer may be contacted on
                Landline No. 01902256061 and mobile No. 8527125333.
              </span>
            </li>
            <li>
              <span style="text-align: justify">
                The convenience charges of booking will be borne by the
                customers if any arising out of selection of payment method.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="Flex_Row">
        <div class="Flex_Cell" style="margin-left: 35px">
          <ul>
            <li>
              <span
                style="text-align: justify"
              >Cancellation of ticket will be applicable only till 72 Hrs prior to visit date and time.</span>
            </li>
            <!-- <li>
              <span style="text-align: justify">
            For refund tourists are requested to go the "My Visit" page and click on the "Cancel Ticket" Button.-->
            <!-- <img
                  src="../assets/images/Email1.png"
                  valign="bottom"
            />-->
            <!-- </span>
            </li>
            <li>
              <span
                style="text-align: justify"
              >The refund will be initiated at the time of cancellation.</span>
            </li>
            <li>
              <span
                style="text-align: justify"
              >The refund amount will be credited within 4 to 7 working days after the refund is initiate into the original payment mode that was used for booking the ticket.</span>
            </li>-->
            <li>
              <span style="text-align: justify">
                In case of any issue, The tourists are requested to send an E-mail with the Ticket No, Name and Mobile No. through which ticket was booked on
                <img
                  src="../assets/images/Email1.png"
                  valign="bottom"
                />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isCancellationPolicy: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.tblRow {
  border-bottom: solid 1px darkgray;
  padding-top: 5px;
  padding-bottom: 5px;
}
/* #tblPrint {
  background: url("../assets/images/AOC_Logo.png");
  background-repeat: no-repeat;
  align-items: center;
} */
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divSummary {
  margin-left: 4px;
  margin-right: 5px;
  /* border: dotted 1px darkgray;
        border-radius: 5px;
        padding: 5px 0px 0px 5px; */
}
.ekkGrid > .Flex_Row:hover:not(.GridHeader),
.ekkGrid > .GridContent > .Flex_Row:hover:not(.GridHeader) {
  background-color: #ffa50069;
  color: black;
}

.RedBorder {
  padding: 10px;
  margin: 10px;
  border: solid 3px red;
}

.GreenBorder {
  padding: 10px;
  margin: 10px;
  border: solid 3px green;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
.wrapText {
  overflow-wrap: anywhere;
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  border: solid 1px;
  border-radius: 4px;
  top: 110px;
  position: absolute;
  min-height: 256px;
  right: 380px;
  /* background-color: ;rgba(255, 248, 248, 0.86); */
  background-color: ghostwhite;
  -webkit-box-shadow: 1px 1px 20px 1px white;
  box-shadow: 1px 1px 20px 1px white;
  border-radius: 8px 8px 8px 8px;
  z-index: 2;
  color: black !important;
  width: 600px;
}
.PopUpDetail {
  padding: 10px;
  /* min-height: 200px;
        max-height: 400px; */
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 18pt;
  min-height: 38px;
  border-bottom: solid 1px;
  border-radius: 8px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.page {
  width: 100%;
  padding: 10px;
  margin: 10px;
  /* border: solid 1px black; */
}
.TableGrid {
  table-layout: fixed;
}
.TableGrid tr:first-child td {
  font-weight: bold;
}
.TableGrid td {
  border-top: 0.01em solid darkgray;
  border-right: 0.01em solid darkgray;
  word-wrap: break-word;
  letter-spacing: 0.5px;
}
li span {
  font-size: 15px;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .imgHeight {
  }
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .imgHeight {
    height: 60px;
  }
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TermNCond.vue